import React, { PropsWithChildren } from "react";
import { FormattedMessage } from "react-intl";
import { Alert } from "react-bootstrap";

interface AlertWrapperProps {
  error: { id: string; defaultMessage: string } | null;
  success?: { id: string; defaultMessage: string } | null;
}

export function AlertWrapper(props: PropsWithChildren<AlertWrapperProps>): JSX.Element {
  if (props.error) {
    return (
      <>
        <Alert variant="danger">
          <strong>
            <FormattedMessage {...props.error} />
          </strong>
        </Alert>
        {props.children}
      </>
    );
  } else {
    return (
      <>
        {props.success && (
          <Alert variant="success">
            <strong>
              <FormattedMessage {...props.success} />
            </strong>
          </Alert>
        )}
        {props.children}
      </>
    );
  }
}
